import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import clsx from 'clsx';
import React from 'react';
import { CryptoSlides } from '@/components/molecules/CryptoCarousel/types';
import TrendDownIcon from '@/public/assets/svg/fees/trend-down.svg';
import TrendUpIcon from '@/public/assets/svg/fees/trend-up.svg';
const ChangeIndicator: React.FC<Pick<CryptoSlides[number], 'change'> & {
  className?: string;
}> = t0 => {
  const $ = _c(10);
  const {
    change,
    className
  } = t0;
  const changeValue = change || 0;
  let t1;
  if ($[0] !== className) {
    t1 = clsx("flex h-full items-center gap-x-3", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== changeValue) {
    t2 = changeValue > 0 ? <TrendUpIcon className="text-green-600" /> : changeValue.toFixed(2) != "0.00" && <TrendDownIcon className="text-primary-600" />;
    $[2] = changeValue;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== changeValue) {
    t3 = changeValue.toFixed(2);
    $[4] = changeValue;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <div className={t1} data-sentry-component="ChangeIndicator" data-sentry-source-file="ChangeIndicator.tsx">{t2}{t3} %</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default ChangeIndicator;